import React from 'react';

import { Text, TextSize, TextType } from '@/shared/ui';

interface DescriptionProps {
    description: string;
}

export const Description: React.FC<DescriptionProps> = ({ description }) => {
    return (
        <Text type={TextType.Paragraph} size={TextSize.LG} name='description'>
            {description}
        </Text>
    );
};
